/**
 * A row of finixt-ui StatCells, one per tile, sharing the width equally.
 */
import { Grid, StatCell } from './finixt.js';

export interface StatTile {
  label: string;
  value: string;
  icon: string;
}

export function StatRow({ tiles }: { tiles: StatTile[] }) {
  return (
    <Grid columns={tiles.length} gap={11}>
      {tiles.map((tile) => (
        <StatCell key={tile.label} icon={tile.icon} label={tile.label} value={tile.value} />
      ))}
    </Grid>
  );
}
